export const PDF_URL_KEY_NAME: string = '_chbaf_pdf_url_';
export const MODAL_ANN_STATE_KEY_NAME: string = '_chbaf_announcement_modal_';
